/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getOrganization = /* GraphQL */ `query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    name
    admins
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    fields {
      nextToken
      __typename
    }
    externalScheduleSources {
      nextToken
      __typename
    }
    gameSchedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationQueryVariables,
  APITypes.GetOrganizationQuery
>;
export const listOrganizations = /* GraphQL */ `query ListOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationsQueryVariables,
  APITypes.ListOrganizationsQuery
>;
export const getProgram = /* GraphQL */ `query GetProgram($id: ID!) {
  getProgram(id: $id) {
    id
    name
    type
    description
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProgramQueryVariables,
  APITypes.GetProgramQuery
>;
export const listPrograms = /* GraphQL */ `query ListPrograms(
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrograms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProgramsQueryVariables,
  APITypes.ListProgramsQuery
>;
export const getLeague = /* GraphQL */ `query GetLeague($id: ID!) {
  getLeague(id: $id) {
    id
    name
    admins
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    teams {
      nextToken
      __typename
    }
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLeagueQueryVariables, APITypes.GetLeagueQuery>;
export const listLeagues = /* GraphQL */ `query ListLeagues(
  $filter: ModelLeagueFilterInput
  $limit: Int
  $nextToken: String
) {
  listLeagues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLeaguesQueryVariables,
  APITypes.ListLeaguesQuery
>;
export const getRestRule = /* GraphQL */ `query GetRestRule($id: ID!) {
  getRestRule(id: $id) {
    id
    name
    ageGroup
    global
    organizationId
    criteria
    weeklyOutsLimit
    pitchLimits {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    organizations {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRestRuleQueryVariables,
  APITypes.GetRestRuleQuery
>;
export const listRestRules = /* GraphQL */ `query ListRestRules(
  $filter: ModelRestRuleFilterInput
  $limit: Int
  $nextToken: String
) {
  listRestRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRestRulesQueryVariables,
  APITypes.ListRestRulesQuery
>;
export const getRestProfile = /* GraphQL */ `query GetRestProfile($id: ID!) {
  getRestProfile(id: $id) {
    id
    restRuleId
    restRule {
      id
      name
      ageGroup
      global
      organizationId
      criteria
      weeklyOutsLimit
      createdAt
      updatedAt
      __typename
    }
    pitchCount
    daysRest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRestProfileQueryVariables,
  APITypes.GetRestProfileQuery
>;
export const listRestProfiles = /* GraphQL */ `query ListRestProfiles(
  $filter: ModelRestProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  listRestProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      restRuleId
      pitchCount
      daysRest
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRestProfilesQueryVariables,
  APITypes.ListRestProfilesQuery
>;
export const getTeam = /* GraphQL */ `query GetTeam($id: ID!) {
  getTeam(id: $id) {
    id
    name
    ageGroup
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    coachUsernames
    players {
      nextToken
      __typename
    }
    coaches {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTeamQueryVariables, APITypes.GetTeamQuery>;
export const listTeams = /* GraphQL */ `query ListTeams(
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTeamsQueryVariables, APITypes.ListTeamsQuery>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    email
    givenName
    familyName
    phone
    safetyCertified
    abcaId
    roles
    teams {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getPlayer = /* GraphQL */ `query GetPlayer($id: ID!) {
  getPlayer(id: $id) {
    id
    name
    dateOfBirth
    town
    state
    pitcher
    catcher
    battingHandedness
    throwingHandedness
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    pitchLogs {
      nextToken
      __typename
    }
    pitchViolations {
      nextToken
      __typename
    }
    parents {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    userAssignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPlayerQueryVariables, APITypes.GetPlayerQuery>;
export const listPlayers = /* GraphQL */ `query ListPlayers(
  $filter: ModelPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlayersQueryVariables,
  APITypes.ListPlayersQuery
>;
export const getPitchLog = /* GraphQL */ `query GetPitchLog($id: ID!) {
  getPitchLog(id: $id) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    playerRosterTeamId
    date
    pitches
    outsRecorded
    isSubstitute
    enteredByUsername
    lastModifiedByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPitchLogQueryVariables,
  APITypes.GetPitchLogQuery
>;
export const listPitchLogs = /* GraphQL */ `query ListPitchLogs(
  $filter: ModelPitchLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listPitchLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      playerId
      teamId
      playerRosterTeamId
      date
      pitches
      outsRecorded
      isSubstitute
      enteredByUsername
      lastModifiedByUsername
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPitchLogsQueryVariables,
  APITypes.ListPitchLogsQuery
>;
export const getPitchLogAuditEntry = /* GraphQL */ `query GetPitchLogAuditEntry($id: ID!) {
  getPitchLogAuditEntry(id: $id) {
    id
    pitchLogId
    action
    changedByUsername
    changedAt
    summary
    beforeSnapshot
    afterSnapshot
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPitchLogAuditEntryQueryVariables,
  APITypes.GetPitchLogAuditEntryQuery
>;
export const listPitchLogAuditEntries = /* GraphQL */ `query ListPitchLogAuditEntries(
  $filter: ModelPitchLogAuditEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  listPitchLogAuditEntries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      pitchLogId
      action
      changedByUsername
      changedAt
      summary
      beforeSnapshot
      afterSnapshot
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPitchLogAuditEntriesQueryVariables,
  APITypes.ListPitchLogAuditEntriesQuery
>;
export const getPitchViolation = /* GraphQL */ `query GetPitchViolation($id: ID!) {
  getPitchViolation(id: $id) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    type
    date
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPitchViolationQueryVariables,
  APITypes.GetPitchViolationQuery
>;
export const listPitchViolations = /* GraphQL */ `query ListPitchViolations(
  $filter: ModelPitchViolationFilterInput
  $limit: Int
  $nextToken: String
) {
  listPitchViolations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      playerId
      type
      date
      details
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPitchViolationsQueryVariables,
  APITypes.ListPitchViolationsQuery
>;
export const getPlayerParent = /* GraphQL */ `query GetPlayerParent($id: ID!) {
  getPlayerParent(id: $id) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    parentEmail
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlayerParentQueryVariables,
  APITypes.GetPlayerParentQuery
>;
export const listPlayerParents = /* GraphQL */ `query ListPlayerParents(
  $filter: ModelPlayerParentFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlayerParents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      playerId
      parentEmail
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlayerParentsQueryVariables,
  APITypes.ListPlayerParentsQuery
>;
export const getSubNotification = /* GraphQL */ `query GetSubNotification($id: ID!) {
  getSubNotification(id: $id) {
    id
    fromTeamId
    toTeamId
    playerId
    date
    note
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubNotificationQueryVariables,
  APITypes.GetSubNotificationQuery
>;
export const listSubNotifications = /* GraphQL */ `query ListSubNotifications(
  $filter: ModelSubNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      fromTeamId
      toTeamId
      playerId
      date
      note
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubNotificationsQueryVariables,
  APITypes.ListSubNotificationsQuery
>;
export const getSeason = /* GraphQL */ `query GetSeason($id: ID!) {
  getSeason(id: $id) {
    id
    name
    year
    startDate
    endDate
    programs {
      nextToken
      __typename
    }
    leagues {
      nextToken
      __typename
    }
    teams {
      nextToken
      __typename
    }
    rosterMemberships {
      nextToken
      __typename
    }
    draftBoards {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    lineupPlans {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSeasonQueryVariables, APITypes.GetSeasonQuery>;
export const listSeasons = /* GraphQL */ `query ListSeasons(
  $filter: ModelSeasonFilterInput
  $limit: Int
  $nextToken: String
) {
  listSeasons(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSeasonsQueryVariables,
  APITypes.ListSeasonsQuery
>;
export const getDraftBoard = /* GraphQL */ `query GetDraftBoard($id: ID!) {
  getDraftBoard(id: $id) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftees {
      nextToken
      __typename
    }
    assignments {
      nextToken
      __typename
    }
    evaluationSessions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDraftBoardQueryVariables,
  APITypes.GetDraftBoardQuery
>;
export const listDraftBoards = /* GraphQL */ `query ListDraftBoards(
  $filter: ModelDraftBoardFilterInput
  $limit: Int
  $nextToken: String
) {
  listDraftBoards(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDraftBoardsQueryVariables,
  APITypes.ListDraftBoardsQuery
>;
export const getEvaluationSession = /* GraphQL */ `query GetEvaluationSession($id: ID!) {
  getEvaluationSession(id: $id) {
    id
    name
    status
    ageGroup
    notes
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    draftBoardId
    players {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEvaluationSessionQueryVariables,
  APITypes.GetEvaluationSessionQuery
>;
export const listEvaluationSessions = /* GraphQL */ `query ListEvaluationSessions(
  $filter: ModelEvaluationSessionFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvaluationSessions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEvaluationSessionsQueryVariables,
  APITypes.ListEvaluationSessionsQuery
>;
export const getEvaluationPlayer = /* GraphQL */ `query GetEvaluationPlayer($id: ID!) {
  getEvaluationPlayer(id: $id) {
    id
    evaluationSessionId
    evaluationSession {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    focus
    homeToFirstSeconds
    firstToSecondSeconds
    catcher
    pitcher
    drafteeId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEvaluationPlayerQueryVariables,
  APITypes.GetEvaluationPlayerQuery
>;
export const listEvaluationPlayers = /* GraphQL */ `query ListEvaluationPlayers(
  $filter: ModelEvaluationPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvaluationPlayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      evaluationSessionId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      focus
      homeToFirstSeconds
      firstToSecondSeconds
      catcher
      pitcher
      drafteeId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEvaluationPlayersQueryVariables,
  APITypes.ListEvaluationPlayersQuery
>;
export const getDraftee = /* GraphQL */ `query GetDraftee($id: ID!) {
  getDraftee(id: $id) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    firstName
    lastName
    dateOfBirth
    town
    state
    parentEmail
    batting
    fielding
    throwing
    baserunning
    coachability
    availabilityRating
    catcher
    pitcher
    finalizedPlayerId
    assignments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDrafteeQueryVariables,
  APITypes.GetDrafteeQuery
>;
export const listDraftees = /* GraphQL */ `query ListDraftees(
  $filter: ModelDrafteeFilterInput
  $limit: Int
  $nextToken: String
) {
  listDraftees(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      draftBoardId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      coachability
      availabilityRating
      catcher
      pitcher
      finalizedPlayerId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDrafteesQueryVariables,
  APITypes.ListDrafteesQuery
>;
export const getDraftAssignment = /* GraphQL */ `query GetDraftAssignment($id: ID!) {
  getDraftAssignment(id: $id) {
    id
    draftBoardId
    draftBoard {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    teamId
    drafteeId
    draftee {
      id
      draftBoardId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      coachability
      availabilityRating
      catcher
      pitcher
      finalizedPlayerId
      createdAt
      updatedAt
      __typename
    }
    playerId
    rosterMembershipId
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDraftAssignmentQueryVariables,
  APITypes.GetDraftAssignmentQuery
>;
export const listDraftAssignments = /* GraphQL */ `query ListDraftAssignments(
  $filter: ModelDraftAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDraftAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      draftBoardId
      teamId
      drafteeId
      playerId
      rosterMembershipId
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDraftAssignmentsQueryVariables,
  APITypes.ListDraftAssignmentsQuery
>;
export const getRosterMembership = /* GraphQL */ `query GetRosterMembership($id: ID!) {
  getRosterMembership(id: $id) {
    id
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    relationship
    isPrimary
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRosterMembershipQueryVariables,
  APITypes.GetRosterMembershipQuery
>;
export const listRosterMemberships = /* GraphQL */ `query ListRosterMemberships(
  $filter: ModelRosterMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  listRosterMemberships(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      playerId
      teamId
      seasonId
      organizationId
      programId
      relationship
      isPrimary
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRosterMembershipsQueryVariables,
  APITypes.ListRosterMembershipsQuery
>;
export const getUserAssignment = /* GraphQL */ `query GetUserAssignment($id: ID!) {
  getUserAssignment(id: $id) {
    id
    userId
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    programId
    program {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    leagueId
    league {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    playerId
    player {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    relationship
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserAssignmentQueryVariables,
  APITypes.GetUserAssignmentQuery
>;
export const listUserAssignments = /* GraphQL */ `query ListUserAssignments(
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserAssignmentsQueryVariables,
  APITypes.ListUserAssignmentsQuery
>;
export const getCoachLineupPlan = /* GraphQL */ `query GetCoachLineupPlan($id: ID!) {
  getCoachLineupPlan(id: $id) {
    id
    teamId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    seasonId
    season {
      id
      name
      year
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    title
    gameDate
    opponentName
    inningsPlanned
    battingOrder
    defensiveAssignments
    notes
    createdByUsername
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCoachLineupPlanQueryVariables,
  APITypes.GetCoachLineupPlanQuery
>;
export const listCoachLineupPlans = /* GraphQL */ `query ListCoachLineupPlans(
  $filter: ModelCoachLineupPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listCoachLineupPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      teamId
      seasonId
      title
      gameDate
      opponentName
      inningsPlanned
      battingOrder
      defensiveAssignments
      notes
      createdByUsername
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCoachLineupPlansQueryVariables,
  APITypes.ListCoachLineupPlansQuery
>;
export const getTeamPlayer = /* GraphQL */ `query GetTeamPlayer($id: ID!) {
  getTeamPlayer(id: $id) {
    id
    teamID
    playerID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTeamPlayerQueryVariables,
  APITypes.GetTeamPlayerQuery
>;
export const listTeamPlayers = /* GraphQL */ `query ListTeamPlayers(
  $filter: ModelTeamPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamPlayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      teamID
      playerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamPlayersQueryVariables,
  APITypes.ListTeamPlayersQuery
>;
export const getField = /* GraphQL */ `query GetField($id: ID!) {
  getField(id: $id) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    address
    town
    state
    surfaceType
    notes
    availability {
      nextToken
      __typename
    }
    schedules {
      nextToken
      __typename
    }
    practices {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFieldQueryVariables, APITypes.GetFieldQuery>;
export const listFields = /* GraphQL */ `query ListFields(
  $filter: ModelFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listFields(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFieldsQueryVariables,
  APITypes.ListFieldsQuery
>;
export const getFieldAvailability = /* GraphQL */ `query GetFieldAvailability($id: ID!) {
  getFieldAvailability(id: $id) {
    id
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    organizationId
    date
    startTime
    endTime
    status
    source
    sourceRef
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFieldAvailabilityQueryVariables,
  APITypes.GetFieldAvailabilityQuery
>;
export const listFieldAvailabilities = /* GraphQL */ `query ListFieldAvailabilities(
  $filter: ModelFieldAvailabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  listFieldAvailabilities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      fieldId
      organizationId
      date
      startTime
      endTime
      status
      source
      sourceRef
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFieldAvailabilitiesQueryVariables,
  APITypes.ListFieldAvailabilitiesQuery
>;
export const getExternalScheduleSource = /* GraphQL */ `query GetExternalScheduleSource($id: ID!) {
  getExternalScheduleSource(id: $id) {
    id
    organizationId
    organization {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    name
    sourceType
    url
    status
    lastImportedAt
    lastError
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExternalScheduleSourceQueryVariables,
  APITypes.GetExternalScheduleSourceQuery
>;
export const listExternalScheduleSources = /* GraphQL */ `query ListExternalScheduleSources(
  $filter: ModelExternalScheduleSourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listExternalScheduleSources(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      name
      sourceType
      url
      status
      lastImportedAt
      lastError
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExternalScheduleSourcesQueryVariables,
  APITypes.ListExternalScheduleSourcesQuery
>;
export const getPractice = /* GraphQL */ `query GetPractice($id: ID!) {
  getPractice(id: $id) {
    id
    organizationId
    teamId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    date
    startTime
    endTime
    status
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPracticeQueryVariables,
  APITypes.GetPracticeQuery
>;
export const listPractices = /* GraphQL */ `query ListPractices(
  $filter: ModelPracticeFilterInput
  $limit: Int
  $nextToken: String
) {
  listPractices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationId
      teamId
      fieldId
      date
      startTime
      endTime
      status
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPracticesQueryVariables,
  APITypes.ListPracticesQuery
>;
export const getGameSchedule = /* GraphQL */ `query GetGameSchedule($id: ID!) {
  getGameSchedule(id: $id) {
    id
    organizationId
    teamId
    leagueId
    fieldId
    field {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    title
    scheduleType
    date
    startTime
    endTime
    opponentName
    externalSourceId
    externalEventId
    conflictStatus
    conflictDetails
    notes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGameScheduleQueryVariables,
  APITypes.GetGameScheduleQuery
>;
export const listGameSchedules = /* GraphQL */ `query ListGameSchedules(
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  listGameSchedules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGameSchedulesQueryVariables,
  APITypes.ListGameSchedulesQuery
>;
export const getUserTeams = /* GraphQL */ `query GetUserTeams($id: ID!) {
  getUserTeams(id: $id) {
    id
    teamId
    userId
    team {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      email
      givenName
      familyName
      phone
      safetyCertified
      abcaId
      roles
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserTeamsQueryVariables,
  APITypes.GetUserTeamsQuery
>;
export const listUserTeams = /* GraphQL */ `query ListUserTeams(
  $filter: ModelUserTeamsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      teamId
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserTeamsQueryVariables,
  APITypes.ListUserTeamsQuery
>;
export const organizationsByRestRuleId = /* GraphQL */ `query OrganizationsByRestRuleId(
  $restRuleId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
) {
  organizationsByRestRuleId(
    restRuleId: $restRuleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      admins
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationsByRestRuleIdQueryVariables,
  APITypes.OrganizationsByRestRuleIdQuery
>;
export const programsByOrganizationId = /* GraphQL */ `query ProgramsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  programsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProgramsByOrganizationIdQueryVariables,
  APITypes.ProgramsByOrganizationIdQuery
>;
export const programsBySeasonId = /* GraphQL */ `query ProgramsBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  programsBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      description
      organizationId
      seasonId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProgramsBySeasonIdQueryVariables,
  APITypes.ProgramsBySeasonIdQuery
>;
export const leaguesByOrganizationId = /* GraphQL */ `query LeaguesByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLeagueFilterInput
  $limit: Int
  $nextToken: String
) {
  leaguesByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LeaguesByOrganizationIdQueryVariables,
  APITypes.LeaguesByOrganizationIdQuery
>;
export const leaguesBySeasonId = /* GraphQL */ `query LeaguesBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLeagueFilterInput
  $limit: Int
  $nextToken: String
) {
  leaguesBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LeaguesBySeasonIdQueryVariables,
  APITypes.LeaguesBySeasonIdQuery
>;
export const leaguesByRestRuleId = /* GraphQL */ `query LeaguesByRestRuleId(
  $restRuleId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLeagueFilterInput
  $limit: Int
  $nextToken: String
) {
  leaguesByRestRuleId(
    restRuleId: $restRuleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      admins
      organizationId
      seasonId
      restRuleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LeaguesByRestRuleIdQueryVariables,
  APITypes.LeaguesByRestRuleIdQuery
>;
export const restProfilesByRestRuleId = /* GraphQL */ `query RestProfilesByRestRuleId(
  $restRuleId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRestProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  restProfilesByRestRuleId(
    restRuleId: $restRuleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      restRuleId
      pitchCount
      daysRest
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RestProfilesByRestRuleIdQueryVariables,
  APITypes.RestProfilesByRestRuleIdQuery
>;
export const teamsByProgramId = /* GraphQL */ `query TeamsByProgramId(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
) {
  teamsByProgramId(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamsByProgramIdQueryVariables,
  APITypes.TeamsByProgramIdQuery
>;
export const teamsByLeagueId = /* GraphQL */ `query TeamsByLeagueId(
  $leagueId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
) {
  teamsByLeagueId(
    leagueId: $leagueId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamsByLeagueIdQueryVariables,
  APITypes.TeamsByLeagueIdQuery
>;
export const teamsBySeasonId = /* GraphQL */ `query TeamsBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
) {
  teamsBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamsBySeasonIdQueryVariables,
  APITypes.TeamsBySeasonIdQuery
>;
export const teamsByOrganizationId = /* GraphQL */ `query TeamsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
) {
  teamsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      ageGroup
      programId
      leagueId
      seasonId
      organizationId
      coachUsernames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamsByOrganizationIdQueryVariables,
  APITypes.TeamsByOrganizationIdQuery
>;
export const playersByTeamId = /* GraphQL */ `query PlayersByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  playersByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      dateOfBirth
      town
      state
      pitcher
      catcher
      battingHandedness
      throwingHandedness
      teamId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayersByTeamIdQueryVariables,
  APITypes.PlayersByTeamIdQuery
>;
export const pitchLogsByPlayerId = /* GraphQL */ `query PitchLogsByPlayerId(
  $playerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPitchLogFilterInput
  $limit: Int
  $nextToken: String
) {
  pitchLogsByPlayerId(
    playerId: $playerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      teamId
      playerRosterTeamId
      date
      pitches
      outsRecorded
      isSubstitute
      enteredByUsername
      lastModifiedByUsername
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PitchLogsByPlayerIdQueryVariables,
  APITypes.PitchLogsByPlayerIdQuery
>;
export const pitchLogAuditByPitchLogId = /* GraphQL */ `query PitchLogAuditByPitchLogId(
  $pitchLogId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPitchLogAuditEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  pitchLogAuditByPitchLogId(
    pitchLogId: $pitchLogId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      pitchLogId
      action
      changedByUsername
      changedAt
      summary
      beforeSnapshot
      afterSnapshot
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PitchLogAuditByPitchLogIdQueryVariables,
  APITypes.PitchLogAuditByPitchLogIdQuery
>;
export const pitchViolationsByPlayerId = /* GraphQL */ `query PitchViolationsByPlayerId(
  $playerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPitchViolationFilterInput
  $limit: Int
  $nextToken: String
) {
  pitchViolationsByPlayerId(
    playerId: $playerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      type
      date
      details
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PitchViolationsByPlayerIdQueryVariables,
  APITypes.PitchViolationsByPlayerIdQuery
>;
export const playerParentsByPlayerId = /* GraphQL */ `query PlayerParentsByPlayerId(
  $playerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPlayerParentFilterInput
  $limit: Int
  $nextToken: String
) {
  playerParentsByPlayerId(
    playerId: $playerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      parentEmail
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerParentsByPlayerIdQueryVariables,
  APITypes.PlayerParentsByPlayerIdQuery
>;
export const draftBoardsByOrganizationId = /* GraphQL */ `query DraftBoardsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftBoardFilterInput
  $limit: Int
  $nextToken: String
) {
  draftBoardsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftBoardsByOrganizationIdQueryVariables,
  APITypes.DraftBoardsByOrganizationIdQuery
>;
export const draftBoardsBySeasonId = /* GraphQL */ `query DraftBoardsBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftBoardFilterInput
  $limit: Int
  $nextToken: String
) {
  draftBoardsBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftBoardsBySeasonIdQueryVariables,
  APITypes.DraftBoardsBySeasonIdQuery
>;
export const draftBoardsByProgramId = /* GraphQL */ `query DraftBoardsByProgramId(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftBoardFilterInput
  $limit: Int
  $nextToken: String
) {
  draftBoardsByProgramId(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftBoardsByProgramIdQueryVariables,
  APITypes.DraftBoardsByProgramIdQuery
>;
export const evaluationSessionsByOrganizationId = /* GraphQL */ `query EvaluationSessionsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEvaluationSessionFilterInput
  $limit: Int
  $nextToken: String
) {
  evaluationSessionsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EvaluationSessionsByOrganizationIdQueryVariables,
  APITypes.EvaluationSessionsByOrganizationIdQuery
>;
export const evaluationSessionsBySeasonId = /* GraphQL */ `query EvaluationSessionsBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEvaluationSessionFilterInput
  $limit: Int
  $nextToken: String
) {
  evaluationSessionsBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EvaluationSessionsBySeasonIdQueryVariables,
  APITypes.EvaluationSessionsBySeasonIdQuery
>;
export const evaluationSessionsByProgramId = /* GraphQL */ `query EvaluationSessionsByProgramId(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEvaluationSessionFilterInput
  $limit: Int
  $nextToken: String
) {
  evaluationSessionsByProgramId(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EvaluationSessionsByProgramIdQueryVariables,
  APITypes.EvaluationSessionsByProgramIdQuery
>;
export const evaluationSessionsByDraftBoardId = /* GraphQL */ `query EvaluationSessionsByDraftBoardId(
  $draftBoardId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEvaluationSessionFilterInput
  $limit: Int
  $nextToken: String
) {
  evaluationSessionsByDraftBoardId(
    draftBoardId: $draftBoardId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      ageGroup
      notes
      organizationId
      seasonId
      programId
      draftBoardId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EvaluationSessionsByDraftBoardIdQueryVariables,
  APITypes.EvaluationSessionsByDraftBoardIdQuery
>;
export const evaluationPlayersByEvaluationSessionId = /* GraphQL */ `query EvaluationPlayersByEvaluationSessionId(
  $evaluationSessionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEvaluationPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  evaluationPlayersByEvaluationSessionId(
    evaluationSessionId: $evaluationSessionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      evaluationSessionId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      focus
      homeToFirstSeconds
      firstToSecondSeconds
      catcher
      pitcher
      drafteeId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EvaluationPlayersByEvaluationSessionIdQueryVariables,
  APITypes.EvaluationPlayersByEvaluationSessionIdQuery
>;
export const drafteesByDraftBoardId = /* GraphQL */ `query DrafteesByDraftBoardId(
  $draftBoardId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDrafteeFilterInput
  $limit: Int
  $nextToken: String
) {
  drafteesByDraftBoardId(
    draftBoardId: $draftBoardId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      draftBoardId
      firstName
      lastName
      dateOfBirth
      town
      state
      parentEmail
      batting
      fielding
      throwing
      baserunning
      coachability
      availabilityRating
      catcher
      pitcher
      finalizedPlayerId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DrafteesByDraftBoardIdQueryVariables,
  APITypes.DrafteesByDraftBoardIdQuery
>;
export const draftAssignmentsByDraftBoardId = /* GraphQL */ `query DraftAssignmentsByDraftBoardId(
  $draftBoardId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  draftAssignmentsByDraftBoardId(
    draftBoardId: $draftBoardId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      draftBoardId
      teamId
      drafteeId
      playerId
      rosterMembershipId
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftAssignmentsByDraftBoardIdQueryVariables,
  APITypes.DraftAssignmentsByDraftBoardIdQuery
>;
export const draftAssignmentsByTeamId = /* GraphQL */ `query DraftAssignmentsByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  draftAssignmentsByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      draftBoardId
      teamId
      drafteeId
      playerId
      rosterMembershipId
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftAssignmentsByTeamIdQueryVariables,
  APITypes.DraftAssignmentsByTeamIdQuery
>;
export const draftAssignmentsByDrafteeId = /* GraphQL */ `query DraftAssignmentsByDrafteeId(
  $drafteeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  draftAssignmentsByDrafteeId(
    drafteeId: $drafteeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      draftBoardId
      teamId
      drafteeId
      playerId
      rosterMembershipId
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftAssignmentsByDrafteeIdQueryVariables,
  APITypes.DraftAssignmentsByDrafteeIdQuery
>;
export const draftAssignmentsByPlayerId = /* GraphQL */ `query DraftAssignmentsByPlayerId(
  $playerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDraftAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  draftAssignmentsByPlayerId(
    playerId: $playerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      draftBoardId
      teamId
      drafteeId
      playerId
      rosterMembershipId
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DraftAssignmentsByPlayerIdQueryVariables,
  APITypes.DraftAssignmentsByPlayerIdQuery
>;
export const rosterMembershipsByPlayerId = /* GraphQL */ `query RosterMembershipsByPlayerId(
  $playerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRosterMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  rosterMembershipsByPlayerId(
    playerId: $playerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      teamId
      seasonId
      organizationId
      programId
      relationship
      isPrimary
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RosterMembershipsByPlayerIdQueryVariables,
  APITypes.RosterMembershipsByPlayerIdQuery
>;
export const rosterMembershipsByTeamId = /* GraphQL */ `query RosterMembershipsByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRosterMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  rosterMembershipsByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      teamId
      seasonId
      organizationId
      programId
      relationship
      isPrimary
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RosterMembershipsByTeamIdQueryVariables,
  APITypes.RosterMembershipsByTeamIdQuery
>;
export const rosterMembershipsBySeasonId = /* GraphQL */ `query RosterMembershipsBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRosterMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  rosterMembershipsBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      teamId
      seasonId
      organizationId
      programId
      relationship
      isPrimary
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RosterMembershipsBySeasonIdQueryVariables,
  APITypes.RosterMembershipsBySeasonIdQuery
>;
export const rosterMembershipsByOrganizationId = /* GraphQL */ `query RosterMembershipsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRosterMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  rosterMembershipsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      teamId
      seasonId
      organizationId
      programId
      relationship
      isPrimary
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RosterMembershipsByOrganizationIdQueryVariables,
  APITypes.RosterMembershipsByOrganizationIdQuery
>;
export const rosterMembershipsByProgramId = /* GraphQL */ `query RosterMembershipsByProgramId(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRosterMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  rosterMembershipsByProgramId(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      playerId
      teamId
      seasonId
      organizationId
      programId
      relationship
      isPrimary
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RosterMembershipsByProgramIdQueryVariables,
  APITypes.RosterMembershipsByProgramIdQuery
>;
export const userAssignmentsByUserId = /* GraphQL */ `query UserAssignmentsByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  userAssignmentsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAssignmentsByUserIdQueryVariables,
  APITypes.UserAssignmentsByUserIdQuery
>;
export const userAssignmentsByOrganizationId = /* GraphQL */ `query UserAssignmentsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  userAssignmentsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAssignmentsByOrganizationIdQueryVariables,
  APITypes.UserAssignmentsByOrganizationIdQuery
>;
export const userAssignmentsByProgramId = /* GraphQL */ `query UserAssignmentsByProgramId(
  $programId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  userAssignmentsByProgramId(
    programId: $programId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAssignmentsByProgramIdQueryVariables,
  APITypes.UserAssignmentsByProgramIdQuery
>;
export const userAssignmentsByLeagueId = /* GraphQL */ `query UserAssignmentsByLeagueId(
  $leagueId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  userAssignmentsByLeagueId(
    leagueId: $leagueId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAssignmentsByLeagueIdQueryVariables,
  APITypes.UserAssignmentsByLeagueIdQuery
>;
export const userAssignmentsByTeamId = /* GraphQL */ `query UserAssignmentsByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  userAssignmentsByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAssignmentsByTeamIdQueryVariables,
  APITypes.UserAssignmentsByTeamIdQuery
>;
export const userAssignmentsByPlayerId = /* GraphQL */ `query UserAssignmentsByPlayerId(
  $playerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  userAssignmentsByPlayerId(
    playerId: $playerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      programId
      leagueId
      teamId
      playerId
      relationship
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAssignmentsByPlayerIdQueryVariables,
  APITypes.UserAssignmentsByPlayerIdQuery
>;
export const coachLineupPlansByTeamId = /* GraphQL */ `query CoachLineupPlansByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCoachLineupPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  coachLineupPlansByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamId
      seasonId
      title
      gameDate
      opponentName
      inningsPlanned
      battingOrder
      defensiveAssignments
      notes
      createdByUsername
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CoachLineupPlansByTeamIdQueryVariables,
  APITypes.CoachLineupPlansByTeamIdQuery
>;
export const coachLineupPlansBySeasonId = /* GraphQL */ `query CoachLineupPlansBySeasonId(
  $seasonId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCoachLineupPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  coachLineupPlansBySeasonId(
    seasonId: $seasonId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamId
      seasonId
      title
      gameDate
      opponentName
      inningsPlanned
      battingOrder
      defensiveAssignments
      notes
      createdByUsername
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CoachLineupPlansBySeasonIdQueryVariables,
  APITypes.CoachLineupPlansBySeasonIdQuery
>;
export const teamPlayersByTeamID = /* GraphQL */ `query TeamPlayersByTeamID(
  $teamID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  teamPlayersByTeamID(
    teamID: $teamID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamID
      playerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamPlayersByTeamIDQueryVariables,
  APITypes.TeamPlayersByTeamIDQuery
>;
export const teamPlayersByPlayerID = /* GraphQL */ `query TeamPlayersByPlayerID(
  $playerID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  teamPlayersByPlayerID(
    playerID: $playerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamID
      playerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamPlayersByPlayerIDQueryVariables,
  APITypes.TeamPlayersByPlayerIDQuery
>;
export const fieldsByOrganizationId = /* GraphQL */ `query FieldsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      name
      address
      town
      state
      surfaceType
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldsByOrganizationIdQueryVariables,
  APITypes.FieldsByOrganizationIdQuery
>;
export const fieldAvailabilitiesByFieldId = /* GraphQL */ `query FieldAvailabilitiesByFieldId(
  $fieldId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFieldAvailabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldAvailabilitiesByFieldId(
    fieldId: $fieldId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      fieldId
      organizationId
      date
      startTime
      endTime
      status
      source
      sourceRef
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldAvailabilitiesByFieldIdQueryVariables,
  APITypes.FieldAvailabilitiesByFieldIdQuery
>;
export const fieldAvailabilitiesByOrganizationId = /* GraphQL */ `query FieldAvailabilitiesByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFieldAvailabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldAvailabilitiesByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      fieldId
      organizationId
      date
      startTime
      endTime
      status
      source
      sourceRef
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldAvailabilitiesByOrganizationIdQueryVariables,
  APITypes.FieldAvailabilitiesByOrganizationIdQuery
>;
export const fieldAvailabilitiesByDate = /* GraphQL */ `query FieldAvailabilitiesByDate(
  $date: AWSDate!
  $sortDirection: ModelSortDirection
  $filter: ModelFieldAvailabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  fieldAvailabilitiesByDate(
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      fieldId
      organizationId
      date
      startTime
      endTime
      status
      source
      sourceRef
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FieldAvailabilitiesByDateQueryVariables,
  APITypes.FieldAvailabilitiesByDateQuery
>;
export const externalScheduleSourcesByOrganizationId = /* GraphQL */ `query ExternalScheduleSourcesByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelExternalScheduleSourceFilterInput
  $limit: Int
  $nextToken: String
) {
  externalScheduleSourcesByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      name
      sourceType
      url
      status
      lastImportedAt
      lastError
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ExternalScheduleSourcesByOrganizationIdQueryVariables,
  APITypes.ExternalScheduleSourcesByOrganizationIdQuery
>;
export const practicesByOrganizationId = /* GraphQL */ `query PracticesByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPracticeFilterInput
  $limit: Int
  $nextToken: String
) {
  practicesByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      fieldId
      date
      startTime
      endTime
      status
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PracticesByOrganizationIdQueryVariables,
  APITypes.PracticesByOrganizationIdQuery
>;
export const practicesByTeamId = /* GraphQL */ `query PracticesByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPracticeFilterInput
  $limit: Int
  $nextToken: String
) {
  practicesByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      fieldId
      date
      startTime
      endTime
      status
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PracticesByTeamIdQueryVariables,
  APITypes.PracticesByTeamIdQuery
>;
export const practicesByFieldId = /* GraphQL */ `query PracticesByFieldId(
  $fieldId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPracticeFilterInput
  $limit: Int
  $nextToken: String
) {
  practicesByFieldId(
    fieldId: $fieldId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      fieldId
      date
      startTime
      endTime
      status
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PracticesByFieldIdQueryVariables,
  APITypes.PracticesByFieldIdQuery
>;
export const practicesByDate = /* GraphQL */ `query PracticesByDate(
  $date: AWSDate!
  $sortDirection: ModelSortDirection
  $filter: ModelPracticeFilterInput
  $limit: Int
  $nextToken: String
) {
  practicesByDate(
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      fieldId
      date
      startTime
      endTime
      status
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PracticesByDateQueryVariables,
  APITypes.PracticesByDateQuery
>;
export const gameSchedulesByOrganizationId = /* GraphQL */ `query GameSchedulesByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  gameSchedulesByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameSchedulesByOrganizationIdQueryVariables,
  APITypes.GameSchedulesByOrganizationIdQuery
>;
export const gameSchedulesByTeamId = /* GraphQL */ `query GameSchedulesByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  gameSchedulesByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameSchedulesByTeamIdQueryVariables,
  APITypes.GameSchedulesByTeamIdQuery
>;
export const gameSchedulesByLeagueId = /* GraphQL */ `query GameSchedulesByLeagueId(
  $leagueId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  gameSchedulesByLeagueId(
    leagueId: $leagueId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameSchedulesByLeagueIdQueryVariables,
  APITypes.GameSchedulesByLeagueIdQuery
>;
export const gameSchedulesByFieldId = /* GraphQL */ `query GameSchedulesByFieldId(
  $fieldId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  gameSchedulesByFieldId(
    fieldId: $fieldId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameSchedulesByFieldIdQueryVariables,
  APITypes.GameSchedulesByFieldIdQuery
>;
export const gameSchedulesByDate = /* GraphQL */ `query GameSchedulesByDate(
  $date: AWSDate!
  $sortDirection: ModelSortDirection
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  gameSchedulesByDate(
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameSchedulesByDateQueryVariables,
  APITypes.GameSchedulesByDateQuery
>;
export const gameSchedulesByExternalSourceId = /* GraphQL */ `query GameSchedulesByExternalSourceId(
  $externalSourceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelGameScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  gameSchedulesByExternalSourceId(
    externalSourceId: $externalSourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      teamId
      leagueId
      fieldId
      title
      scheduleType
      date
      startTime
      endTime
      opponentName
      externalSourceId
      externalEventId
      conflictStatus
      conflictDetails
      notes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameSchedulesByExternalSourceIdQueryVariables,
  APITypes.GameSchedulesByExternalSourceIdQuery
>;
export const userTeamsByTeamId = /* GraphQL */ `query UserTeamsByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserTeamsFilterInput
  $limit: Int
  $nextToken: String
) {
  userTeamsByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamId
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserTeamsByTeamIdQueryVariables,
  APITypes.UserTeamsByTeamIdQuery
>;
export const userTeamsByUserId = /* GraphQL */ `query UserTeamsByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserTeamsFilterInput
  $limit: Int
  $nextToken: String
) {
  userTeamsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamId
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserTeamsByUserIdQueryVariables,
  APITypes.UserTeamsByUserIdQuery
>;
